import { render, staticRenderFns } from "./ShowItem.vue?vue&type=template&id=34377e50&scoped=true"
import script from "./ShowItem.vue?vue&type=script&lang=js"
export * from "./ShowItem.vue?vue&type=script&lang=js"
import style0 from "./ShowItem.vue?vue&type=style&index=0&id=34377e50&prod&scoped=true&lang=css"
import style1 from "./ShowItem.vue?vue&type=style&index=1&id=34377e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34377e50",
  null
  
)

export default component.exports